import { useState } from "react";

import './Loading.css';

export default function Comp_Loading() {

    return (
        <div className="Comp_Loading">            
            <div className="circle">
                <div className="dot" />
                <div className="outline" />
            </div>
            <div className="circle">
                <div className="dot" />
                <div className="outline" />
            </div>
            <div className="circle">
                <div className="dot" />
                <div className="outline" />
            </div>
            <div className="circle">
                <div className="dot" />
                <div className="outline" />
            </div>
        </div>
    );
}
